import React, { FunctionComponent } from 'react';
import { SbBlokData } from '@storyblok/react';

import { Button, Heading, OrderedList2 } from '@savebetter/components';

import { LinkProps } from './Link';
import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface Step extends SbBlokData {
  text: string;
  media: MediaProps[];
}

interface Blok extends PageSectionBlok {
  title: string;
  steps: Step[];
  link: LinkProps[];
}

interface StepsProps extends PageSectionProps {
  blok: Blok;
}

export const Stepsv2: FunctionComponent<React.PropsWithChildren<StepsProps>> = ({ blok, sectionClassName }) => {
  const {
    hasBackground,
    hasBorder,
    title,
    steps = [],
    sectionTitle,
    link = [],
    hasPaddingTop,
    hasPaddingBottom
  } = blok;
  const btn = link.length > 0 ? link[0] : null;

  return (
    <Section
      width="lg"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      {title && <PageSectionHeader className="sm:text-center">{title}</PageSectionHeader>}
      <OrderedList2 orderedList={steps} />
      {sectionTitle && (
        <Heading
          level="2"
          kind="1"
          className="text-center lg:text-4xl lg:h-32 md:text-4xl sm:text-2xl md:pt-8 sm:pt-16"
        >
          {sectionTitle}
        </Heading>
      )}
      {btn && (
        <div className="flex justify-center">
          <Button kind="primary" className="mt-12 lg:mt-16" href={btn.url}>
            {btn.text}
          </Button>
        </div>
      )}
    </Section>
  );
};
